import { supabase } from './supabase'

function getLocalDate() {
  const d = new Date()
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export async function updateStreak(userId) {
  const today = getLocalDate()
  const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0]

  // Get current profile
  const { data: profile } = await supabase
    .from('profiles')
    .select('streak, last_checkin_date')
    .eq('id', userId)
    .single()

  if (!profile) return 0

  // Check if user actually earned any points today
  const { data: todayTasks } = await supabase
    .from('manual_tasks')
    .select('id')
    .eq('user_id', userId)
    .eq('date', today)
    .eq('flagged', false)
    .limit(1)

  const earnedPointsToday = todayTasks && todayTasks.length > 0

  // If already recorded today's streak and nothing new, return current
  if (profile.last_checkin_date === today) {
    return profile.streak
  }

  // Only update streak if user earned points today
  if (!earnedPointsToday) {
    // No points earned today — check if streak should be broken
    // If last checkin was yesterday or earlier and today has no points, don't update
    return profile.streak || 0
  }

  // User earned points today — calculate new streak
  let newStreak = 1
  if (profile.last_checkin_date === yesterday) {
    // Consecutive day — increment
    newStreak = (profile.streak || 0) + 1
  } else {
    // Streak broken — reset to 1
    newStreak = 1
  }

  await supabase
    .from('profiles')
    .update({ streak: newStreak, last_checkin_date: today })
    .eq('id', userId)

  return newStreak
}
